var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0719 4.68868C11.7108 2.3276 7.88277 2.3276 5.52169 4.68868C3.16061 7.04977 3.16061 10.8778 5.52169 13.2389L9.06042 16.7776C9.46733 17.1846 10.1263 17.1845 10.5335 16.7773L14.0719 13.2389C16.433 10.8778 16.433 7.04977 14.0719 4.68868ZM4.63719 3.80418C7.48677 0.954597 12.1068 0.954597 14.9564 3.80418C17.806 6.65376 17.806 11.2738 14.9564 14.1234L11.4181 17.6618C10.5226 18.5572 9.07167 18.5579 8.17592 17.6622L4.63719 14.1234C1.7876 11.2738 1.7876 6.65376 4.63719 3.80418ZM9.79681 7.08748C8.76054 7.08748 7.92049 7.92754 7.92049 8.9638C7.92049 10.0001 8.76054 10.8401 9.79681 10.8401C10.8331 10.8401 11.6731 10.0001 11.6731 8.9638C11.6731 7.92754 10.8331 7.08748 9.79681 7.08748ZM6.6696 8.9638C6.6696 7.23669 8.0697 5.8366 9.79681 5.8366C11.5239 5.8366 12.924 7.23669 12.924 8.9638C12.924 10.6909 11.5239 12.091 9.79681 12.091C8.0697 12.091 6.6696 10.6909 6.6696 8.9638Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon2);
export default __webpack_public_path__ + "static/media/location-icon-2.0c7da861db2ec58c89cee5b2c4764a2d.svg";
export { ForwardRef as ReactComponent };